import { render } from "./HookOption.vue?vue&type=template&id=408fe6e0&scoped=true"
import script from "./HookOption.vue?vue&type=script&lang=js"
export * from "./HookOption.vue?vue&type=script&lang=js"

import "./HookOption.vue?vue&type=style&index=0&id=408fe6e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-408fe6e0"]])

export default __exports__